<template>
    <div class="cta-chart-container">
        <div :id="`chart-${chartId}`"></div>
        <img v-if="domainPreferred.length > 2 || forceBigOverlay" src="/images/design/cta/ChartOverlayBig.svg" class="overlay-big" />
        <img v-else src="/images/design/cta/ChartOverlay.svg" class="overlay" />
        <div v-for="(domain, index) in domainTranslations" :class="`overlay-text-${index + 1}`" :key="domain + index">
            <span>{{ $t(`reportsWeb.${domain.toUpperCase()}_CHARTLABEL`) }}</span>
        </div>
        <div v-for="label in valueLabels" :key="label.key" class="value-label" :style="{ left: `${label.left}px`, top: `${label.top}px` }">
            <span>{{ label.value }}</span>
        </div>
    </div>
</template>
<script src="./CtaSunburstChart.ts" />
<style lang="scss">
.preferred {
    font-weight: 800;
}

body.rendering {
    .overlay-big {
        filter: none;
    }
}

.overlay-big {
    position: absolute;
    width: 225px !important;
    height: 225px !important;
    pointer-events: none;
    z-index: 10;
    filter: drop-shadow(0 6px 12px rgba(0, 0, 0, 0.2));
}

.overlay {
    position: absolute;
    width: 145px !important;
    height: 145px !important;
    pointer-events: none;
    transform: rotate(-120deg);
    top: 100px;
    left: 75px;
    z-index: 10;
    filter: drop-shadow(0 6px 12px rgba(0, 0, 0, 0.2));
}

.overlay-text {
    position: absolute;
    max-width: 75px;
    text-wrap: wrap;
    z-index: 20;
    text-align: center;
    font-size: 12px;
    color: black;
    font-weight: 600;

    &-1 {
        @extend .overlay-text;
        top: 150px;
        left: 105px;
    }

    &-2 {
        @extend .overlay-text;
        top: 150px;
        left: 220px;
    }

    &-3 {
        @extend .overlay-text;
        top: 250px;
        left: 160px;
    }
}

.body.rendering {
    .value-label {
        display: none;
    }
}

.value-label {
    position: absolute;
    transform: translate(-50%, -50%);
    z-index: 25;
    pointer-events: none;
    font-size: 11px;
    color: black;
    font-weight: 700;
    background: rgba(255, 255, 255, 0.8);
    border-radius: 4px;
    padding: 1px 4px;
    line-height: 1.1;
}

.cta-chart-container {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
